// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  height: 100vh;
  overflow-x: hidden;
}
#app-root {
  height: 100%;
}
.root-layout {
  height: 100%;
}
.app-content {
  min-height: unset;
  display: flex;
  flex-direction: column;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
